import type { InstanceProvider } from '@empathyco/playboard-core-domain'
import type { interfaces } from 'inversify'
import type { Store } from 'vuex'
import type { ContextState } from '../models'
import { TYPES } from '../config/inversify.types'
import { CONTEXT_CONSTS } from '../store/context/context.consts'

export function getInstanceFromStoreProvider({ container }: interfaces.Context): InstanceProvider {
  return () => {
    const store = container.get<Store<unknown>>(TYPES.Store)
    const context = store.getters[
      `${CONTEXT_CONSTS.moduleName}/${CONTEXT_CONSTS.getters.context}`
    ] as ContextState
    return context.instanceId
  }
}
